export const marketingCTAClicked = (destination, page_url, text, type) => {
  window.analytics.track("Marketing CTA Clicked", {
    destination: destination,
    page_url: page_url,
    text: text,
    type: type,
  })
}

export const outboundLinkClicked = (destination, page_url, text, type) => {
  window.analytics.track("Outbound Link Clicked", {
    destination: destination,
    page_url: page_url,
    text: text,
    type: type,
  })
}

export const blogPostAudioPlayed = (
  page_url,
  post_categories,
  post_tags,
  post_title,
  social_network
) => {
  window.analytics.track("Blog Post Audio Played", {
    page_url: page_url,
    post_categories: post_categories,
    post_tags: post_tags,
    post_title: post_title,
    social_network: social_network,
  })
}

export const blogPostVideoPlayed = (
  page_url,
  post_categories,
  post_tags,
  post_title,
  social_network
) => {
  console.log("playing", page_url, post_title)
  window.analytics.track("Blog Post Video Played", {
    page_url: page_url,
    post_categories: post_categories,
    post_tags: post_tags,
    post_title: post_title,
    social_network: social_network,
  })
}

export const emailMarketingOptedIn = (date_opted_in, email, page_url) => {
  window.analytics.track("Email Marketing Opted In", {
    acquisition_source: "blog",
    date_opted_in: date_opted_in,
    email: email,
    page_url: page_url,
  })
}

export const emailMarketingOptedInIdentify = (email) => {
  window.analytics.identify({
    email: email,
    email_marketing_opted_in: true,
  })
}

export const blogPostShareClicked = (
  page_url,
  post_categories,
  post_tags,
  post_title,
  social_network
) => {
  window.analytics.track("Blog Post Share Clicked", {
    page_url: page_url,
    post_categories: post_categories,
    post_tags: post_tags,
    post_title: post_title,
    social_network: social_network,
  })
}
